import { colors } from './colors';
import { typography } from './typography';
import { spacing } from './spacing';
import { animation } from './animation';

import { legacyToBrand2020 } from './legacyToBrand2020';
// eslint-disable-next-line no-unused-vars
import { Theme } from '../types';

export const brand2020: Theme = {
  name: 'BRAND_2020',
  get legacy() {
    return legacyToBrand2020;
  },
  typography,
  colors,
  spacing,
  animation,
};
